import { render } from "./EsgScorecard.vue?vue&type=template&id=09c5a346"
import script from "./EsgScorecard.vue?vue&type=script&lang=js"
export * from "./EsgScorecard.vue?vue&type=script&lang=js"

import "./EsgScorecard.vue?vue&type=style&index=0&id=09c5a346&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__